import clsx from 'clsx'
import React, { ReactNode } from 'react'

import s from './styles.module.scss'

import { DASH_TYPE_ENUM } from './DASH_TYPE_ENUM'
import { LIST_NUMBER_TYPE_ENUM } from './LIST_NUMBER_TYPE_ENUM'
import { LIST_TYPE_ENUM } from './LIST_TYPE_ENUM'

const getListNumberTypeCaracter = (
  num: number,
  listNumberType: LIST_NUMBER_TYPE_ENUM,
) => {
  switch (listNumberType) {
    case LIST_NUMBER_TYPE_ENUM.NUMBER:
      return num
    case LIST_NUMBER_TYPE_ENUM.LETTER:
      return getLetterByIndex(num)
    case LIST_NUMBER_TYPE_ENUM.ROMAN:
      return getRomanByIndex(num)
    default:
      return <></>
  }
}

const getLetterByIndex = (num: number) => {
  if (num >= 1 && num <= 26) {
    return String.fromCharCode(96 + num)
  } else {
    return ''
  }
}

const getRomanByIndex = (num: number) => {
  if (num < 1 || num > 3999) {
    return ''
  }

  const romanNumerals: any = {
    m: 1000,
    cm: 900,
    d: 500,
    cd: 400,
    c: 100,
    xc: 90,
    l: 50,
    xl: 40,
    x: 10,
    ix: 9,
    v: 5,
    iv: 4,
    i: 1,
  }

  let result = ''

  for (const key in romanNumerals) {
    while (num >= romanNumerals[key]) {
      result += key
      num -= romanNumerals[key]
    }
  }

  return result
}

const getDashTypeListCaracter = (dashType: DASH_TYPE_ENUM) => {
  switch (dashType) {
    case DASH_TYPE_ENUM.DASH:
      return <span>-</span>
    case DASH_TYPE_ENUM.POINT:
      return <div className={s.bulletPoint} />
    default:
      return <></>
  }
}

const List = ({
  children,
  type = LIST_TYPE_ENUM.DASH,
  dashType = DASH_TYPE_ENUM.DASH,
  listNumberType = LIST_NUMBER_TYPE_ENUM.NUMBER,
  className,
}: {
  children: ReactNode
  type?: LIST_TYPE_ENUM
  dashType?: DASH_TYPE_ENUM
  listNumberType?: LIST_NUMBER_TYPE_ENUM
  className?: string
}) => {
  return (
    <>
      {type === LIST_TYPE_ENUM.DASH && (
        <ul className={clsx(s.ul, className)}>
          {React.Children.map(children, (child) => (
            <li>
              <div className={s.listStyle}>
                {getDashTypeListCaracter(dashType)}
              </div>
              {child}
            </li>
          ))}
        </ul>
      )}
      {type === LIST_TYPE_ENUM.NUMBER && (
        <ol className={clsx(s.ol, className)}>
          {React.Children.map(children, (child, index) => (
            <li>
              <div className={s.listStyle}>
                {getListNumberTypeCaracter(index + 1, listNumberType)}.
              </div>
              {child}
            </li>
          ))}
        </ol>
      )}
    </>
  )
}
export default List
